import { createGlobalStyle } from "styled-components";

export const lightTheme = {
	body: "#FFF",
	text: "#222222",
	color_primary_600: "#CC8800",
	color_primary_500: "#FFB11A",
	color_primary_400: "#FFC34D",
	color_primary_300: "#FFD480",
	color_primary_200: "#FFE5B3",
	color_primary_100: "#FFF9EB",
	color_status_info_500: "#1A5AFF",
	color_status_info_100: "#EEF3FF",
	color_status_success_500: "#0F9E60",
	color_status_success_100: "#ECFDF5",
	color_status_error_500: "#BF1A2F",
	color_status_info_100: "#FFF2F2",
	color_text_500: "#222222",
	color_text_400: "#404040",
	color_text_300: "#595959",
	color_text_200: "#A8A8A8",
	color_text_100: "#D6D6D6",
	background_500: "#E9E8E8",
	background_400: "#F3F2F2",
	background_300: "#F9F9F9",
	background_200: "#FAFAFA",
	background_100: "#ffffff",
};

export const darkTheme = {
	body: "#FFF",
	text: "#222222",
	color_primary_600: "#CC8800",
	color_primary_500: "#FFB11A",
	color_primary_400: "#FFC34D",
	color_primary_300: "#FFD480",
	color_primary_200: "#FFE5B3",
	color_primary_100: "#FFF9EB",
	color_status_info_500: "#1A5AFF",
	color_status_info_100: "#EEF3FF",
	color_status_success_500: "#0F9E60",
	color_status_success_100: "#ECFDF5",
	color_status_error_500: "#E73232",
	color_status_info_100: "#FFF2F2",
	color_text_500: "#222222",
	color_text_400: "#404040",
	color_text_300: "#595959",
	color_text_200: "#A8A8A8",
	color_text_100: "#D6D6D6",
	background_500: "#E9E8E8",
	background_400: "#F3F2F2",
	background_300: "#F9F9F9",
	background_200: "#FAFAFA",
	background_100: "#ffffff",
};

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: DM Sans, Gilda Display, Tahoma, Helvetica, Arial, Roboto, sans-serif;
  }
`;
